import { render, staticRenderFns } from "./Respuesta.vue?vue&type=template&id=5301ede0&scoped=true"
import script from "./Respuesta.vue?vue&type=script&lang=js"
export * from "./Respuesta.vue?vue&type=script&lang=js"
import style0 from "./Respuesta.vue?vue&type=style&index=0&id=5301ede0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5301ede0",
  null
  
)

export default component.exports